import { useEffect, useState } from "react";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import { Roundtable } from "../../types/Roundtable";

export type RoundtablesResponse = {
  loading: boolean;
  error: boolean;
  roundtables: Roundtable[];
};

export default ({
  communityId,
}: {
  communityId?: string;
}): RoundtablesResponse => {
  const [response, setResponse] = useState<RoundtablesResponse>({
    loading: true,
    error: false,
    roundtables: [],
  });

  useEffect(() => {
    const collection = firestore.collection(DB_PATH.COMMUNITY_ROUNDTABLE);
    const query = communityId
      ? collection.where("communityId", "==", communityId)
      : collection;

    const unsubscribe = query.onSnapshot(
      (snapshot) => {
        const roundtables = snapshot.docs.map((doc) => doc.data() as Roundtable);
        // Soonest first, mirroring the app's ordering.
        roundtables.sort((a, b) =>
          (a.startTime || "").localeCompare(b.startTime || "")
        );
        setResponse({ loading: false, error: false, roundtables });
      },
      (error) => {
        console.error("Error fetching roundtables:", error);
        setResponse((prev) => ({ ...prev, loading: false, error: true }));
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return response;
};
